module.exports = __webpack_public_path__ + "static/img/place_7.94d3d649.png";